import Button from 'react-bootstrap/esm/Button';

const StartNumbersButton = ({ children, ...props }) => {
  return (
    <Button
      className="d-flex gap-2 align-items-center justify-content-center"
      {...props}
    >
      {children}
    </Button>
  );
};

export default StartNumbersButton;
